import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-[#00C853] py-20 px-4" data-id="element-110">
      <div className="max-w-3xl mx-auto" data-id="element-111">
        <div className="relative bg-white rounded-3xl p-8 sm:p-12 text-center shadow-2xl overflow-hidden" data-id="element-112">
          {/* Top accent bar */}
          <div className="absolute top-0 left-0 w-full h-2 bg-[#00C853]" data-id="element-113" />

          {/* Eyebrow badge */}
          <span className="inline-block bg-[#00C853] text-white text-[10px] sm:text-xs font-black px-4 py-1.5 rounded-full uppercase tracking-widest shadow-md mb-6" data-id="element-114">
            ✔ Rischio Zero
          </span>

          {/* Shield */}
          <div className="relative inline-flex items-center justify-center mb-6" data-id="element-115">
            <div className="absolute w-24 h-24 bg-[#00C853]/20 rounded-full blur-2xl" data-id="element-116" />
            <span className="relative text-7xl" data-id="element-117">🛡️</span>
          </div>

          <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] mb-6 tracking-tight" data-id="element-118">
            Garanzia <span className="text-[#00C853]" data-id="element-119">7 Giorni</span>
          </h2>

          <p className="text-[#5A5A66] text-lg font-medium mb-6 max-w-lg mx-auto leading-relaxed" data-id="element-120">
            Apri tutto. Controlla tutto. Usa il materiale.
          </p>

          <p className="text-[#0A0A0A] text-2xl sm:text-3xl font-black mb-4 leading-tight" data-id="element-121">
            Se non sei soddisfatto: <br className="sm:hidden" data-id="element-122" />
            <span className="text-[#00C853]" data-id="element-123">Ti rimborsiamo il 100%.</span>
          </p>

          <p className="text-[#5A5A66] text-base font-bold mb-8 uppercase tracking-widest" data-id="element-124">
            Senza domande.
          </p>

          <span className="inline-block bg-[#00C853]/10 border border-[#00C853]/40 text-[#00C853] text-xs sm:text-sm font-black px-5 py-2.5 rounded-full uppercase tracking-wider" data-id="element-125">
            Tasso di rimborso inferiore all'1%
          </span>
        </div>
      </div>
    </section>;
}